<template>
  <vs-popup
    class="add-lab-cost-popup"
    id="popup"
    :title="isCreateMode ? 'CREATE 3RD PARTY RM' : 'UPDATE 3RD PARTY RM'"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form
          id="create-lab-item-popup"
          @submit.prevent="handleSubmit(onClickSave)"
          autocomplete="off"
        >
          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider
                vid="code"
                name="code"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Code</small>
                <vs-input
                  v-model="form.code"
                  name="code"
                  class="w-full"
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                  val-icon-danger="icon-x"
                  val-icon-pack="feather"
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider
                vid="name"
                name="name"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Name</small>
                <vs-input
                  v-model="form.name"
                  name="name"
                  class="w-full"
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                  val-icon-danger="icon-x"
                  val-icon-pack="feather"
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row hidden">
            <div class="w-full vx-col">
              <ValidationProvider
                vid="unit"
                name="unit"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Unit</small>
                <v-select
                  name="unit"
                  :closeOnSelect="true"
                  v-model="form.unit"
                  :options="['g', 'kg', 'ml', 'l']"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider
                vid="price"
                name="price"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Price (GBP)</small>
                <vs-input
                  v-model="form.price"
                  name="price"
                  class="w-full"
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                  val-icon-danger="icon-x"
                  val-icon-pack="feather"
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider
                vid="is_liquid"
                name="is_liquid"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Liquid Carrier?</small>
                <vs-switch class="mt-2" v-model="form.is_liquid" name="is_liquid"></vs-switch>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button
              button="submit"
              class="mt-2 ml-auto"
              >Save Changes</vs-button
            >
            <vs-button
              @click="resetForm"
              class="mt-2 ml-4"
              type="border"
              color="warning"
              >Reset</vs-button
            >
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const SprayDryCostRepository = RepositoryFactory.get("spray_dry_cost");

import vSelect from "vue-select";

import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";

function initialState() {
  return {
    open: false,
    id: "",
    form: {
      code: "",
      name: "",
      unit: "kg",
      price: "",
      currency_id: 1,
      is_liquid: false,
    },
    isCreateMode: true,
  };
}

export default {
  name: "AddNewLabItemPopUp",
  components: { vSelect },
  mixins: [SuccessMessage, ErrorMessages],
  data() {
    return initialState();
  },
  methods: {
    async openPopup(id = null) {
      Object.assign(this.$data, initialState());
      if (id) {
        this.isCreateMode = false;
        this.id = id;
        await this.getDetails(id);
      }
      this.open = true;
    },
    async getDetails(id) {
      const payload = (
        await SprayDryCostRepository.getSprayDryCarrierDetails(id)
      ).data.data;
      this.form = {
        code: payload.code,
        name: payload.name,
        unit: payload.unit,
        price: payload.price,
        currency_id: payload.currency.id,
        is_liquid: payload.is_liquid,
      };
    },
    resetForm() {
      this.form = {
        code: "",
        name: "",
        unit: "",
        price: "",
      };
      this.$nextTick(() => {
        this.$refs.form.reset();
      });
    },
    async onClickSave() {
      try {
        this.$vs.loading()
        this.form.price = Number(this.form.price).toFixed(2)
        if (this.isCreateMode) {
          await SprayDryCostRepository.createSprayDryCarrier(this.form);
          this.showSuccessMessage("Carrier created successfully");
        } else {
          await SprayDryCostRepository.updateSprayDryCarrier(
            this.id,
            this.form
          );
          this.showSuccessMessage("Carrier updated successfully");
        }
        this.open = false;
        this.$emit("refreshData");
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e);
      }
    },
  },
};
</script>
